import type { FormSelectOption } from '@practium/ui';

export const STATUS_OPTIONS: FormSelectOption[] = [
	{ value: 'true', label: 'Ativo' },
	{ value: 'false', label: 'Inativo' },
];
